// RPECK21/11/2024 - Added to give us the means to use different JS on multiple pages
function loadValues() {

  // RPECK 03/09/2023 - Elements
  document.querySelectorAll(".rpeck_date").forEach(function(element) {

    // RPECK 03/09/2023 - Only proceed if the element is valid
    if(element && 'timestamp' in element.dataset) {

      // RPECK 03/09/2023 - Vars
      var data            = element.dataset;
      var days_element    = element.querySelector('.days');
      var hours_element   = element.querySelector('.hours');
      var minutes_element = element.querySelector('.minutes');
      var seconds_element = element.querySelector('.seconds');
      var countDownDate   = new Date(parseInt(data.year), parseInt(data.month) - 1, parseInt(data.day), parseInt(data.hour), parseInt(data.minute), parseInt(data.seconds));

      // Update the count down every 1 second
      var x = setInterval(function() {
      
      // Get today's date and time
      var now = new Date().getTime();
      
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
      
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Display the result in the element with id="demo"
      days_element.innerText    = ("00" + days).slice(-2);
      hours_element.innerText   = ("00" + hours).slice(-2);
      minutes_element.innerText = ("00" + minutes).slice(-2);
      seconds_element.innerText = ("00" + seconds).slice(-2);
        
        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          element.innerHTML = "EXPIRED";
        }
      }, 1000);
      
    }
          
  });
  
}

if (document.readyState === "loading") {
  // Loading hasn't finished yet
  document.addEventListener("DOMContentLoaded", loadValues);
} else {
  // `DOMContentLoaded` has already fired
  loadValues();
}

/*
  RPECK 26/12/2024 - Updated predictive search using HTML rather than JSON 
  --------------------
*/
document.addEventListener('DOMContentLoaded', function(event) {

  // RPECK 26/12/2024 - Predictive Search
  let   timeout = '';
  const predictive_wrapper = document.getElementById('PredictiveWrapper');
  const predictive_results = document.getElementById('PredictiveResults');

  // RPECK 26/12/2024 - Bind to the search bar
  document.querySelector('.site-header__search-input')?.addEventListener('input', function(e) {

    // RPECK 26/12/2024 - Timeout
    clearTimeout(timeout), timeout = setTimeout(function() {

      // RPECK 26/12/2024 - Fetch the search endpoint using the code from the US site
      // https://auvodka.co.uk/search/suggest?q=marshmellow&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=predictive-search
      // --
      // Ref: ./assets/original-theme.js.liquid#2121  
      const url = new URL('/search/suggest', window.location.origin);
  
      url.searchParams.set('q', e.target.value.trim().replace(/\ /g, "-").toLowerCase());
      url.searchParams.set('resources[limit]', 8);
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('section_id', 'predictive-search');
    
      fetch( decodeURIComponent(url.toString()) )
        .then((response) => {
          return response.text();
        })
        .then((text) => {
  
          // RPECK 26/12/2024 - Sanitize the markup
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  
          // RPECK 26/12/2024 - Populate the results container with the markup
          predictive_results.innerHTML = resultsMarkup;
  
          // RPECK 26/12/2024 - Remove the 'hide' class
          predictive_wrapper.classList.remove('hide');
          
        })
        .catch((error) => {
          throw error; 
        });
      
    });

  }, 500);
  
});



document.addEventListener('rebuy:smartcart.ready', (event) => {

  // RPECK 13/09/2025 - Vars
  // Used to define different parts of the system
  const cart   = event?.detail?.smartcart?.dom?.cart;
  const input  = document.getElementById('rebuy-terms-checkbox');
  const button = document.querySelector('.rebuy-button[disabled]');
  const label  = document.querySelector('label[for="rebuy-terms-checkbox"]');

  // RPECK 13/09/2025 - Function to manage pulse classes
  // This is 
  let change_classes = function(active = false) {

    // RPECK 11/09/2025 - Check to see if the button is checked
    // If so, it means that we should be looking to add the "pulse" CSS class (adds the animation)
    if (active) {
      label?.classList.remove('errorPulse');
    } else {
      label?.classList.add('errorPulse');
    }

  }

  // RPECK 11/09/2025 - Bind the 'click' event to the parentNode of the smartcart
  // This should pass the smartcart object through the event.detail attribute
  cart?.parentNode?.addEventListener('click', function(e){

    // RPECK 11/09/2025 - Various variables to determine if button is clicked
    // Due to the button having a "pointer-events: none" CSS property, this is required to determine if the user clicked it or not
    const rect = button?.getBoundingClientRect();

    // RPECK 13/09/2025 - Only proceed if rect is present
    if (rect) {

      // RPECK 13/09/2025 - Vars
      // Used to determine if the user's cursor is inside the button bounding box
      const inButtonHorizontally = e.clientX >= rect.left && e.clientX <= rect.right;
      const inButtonVertically   = e.clientY >= rect.top && e.clientY <= rect.bottom;

      // RPECK 11/09/2025 - If the click is inside the button's bounding box
      // This ensures we are only proceeding if the button itself was clicked and not another element
      if (inButtonHorizontally && inButtonVertically) {

        // RPECK 11/09/2025 - Stop any propagation of the event
        // This prevents the event bubbling up to other elements
        e.stopPropagation();

        // RPECK 13/09/2025 - Enable the class
        // This is used to determine if the
        change_classes(input.checked);

      }

    }

  });

  // RPECK 13/09/2025 - Add a click event handler to the checkbox
  // This is to get rid of the pulse class
  input?.addEventListener('input', function(event){
    change_classes(true);
  });

});

// RPECK 06/02/2026 - Update the Biscuit Bundle "Add To Cart" value on update
// This was required to give us the ability to keep the theme ATC and update it as needed
// --
// Ref: https://help.biscuitsbundles.com/en/articles/9045771-developer-javascript-and-events#h_74761fb366
document.addEventListener('DOMContentLoaded', function(event){

   const formatter = new Intl.NumberFormat("en-GB", {style: "currency", currency: "GBP"});
   let form        = document.querySelector('biscuits-bundle-form');
   let price_field = document.querySelector('[data-add-to-cart-text]');

   if(form) {
      document.querySelectorAll('.biscuits-bundle-step').forEach((step) => {
        step.addEventListener('biscuits--step-update', (event) => {
          if(price_field) { 
            let price = formatter.format(form.formTotalPrice * 0.01);
            price_field.setAttribute('style', `--price: "${price}";`);
          }
        });
      });
   }

});


document.addEventListener('rebuy:smartcart.ready', (event) => {
  document.querySelectorAll('.rebuy-cart__flyout-item:where(.product-rpeck-bundle-builder-variant-test,.build-your-own-bundle)')?.forEach(function(element){
    element.querySelectorAll('.rebuy-cart__flyout-item-property-value')?.forEach(function(value){

      let text = value.innerHTML.split(",");
      value.replaceChildren();

      text?.forEach(function(t){
        let element = document.createElement('span');
        element.innerHTML = t.trim();
        value.appendChild(element);
      });

    });
  });
});